import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Play = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M17.685 11.115 8.28 5.741A1.524 1.524 0 0 0 6 7.064v10.748a1.524 1.524 0 0 0 2.28 1.323l9.405-5.374a1.524 1.524 0 0 0 0-2.646'
        stroke='currentColor'
        strokeWidth='1.143'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        d='M9.518 4.781C7.982 3.845 6 4.935 6 6.717V18.16c0 1.782 1.982 2.872 3.518 1.936l9.388-5.721a2.26 2.26 0 0 0 0-3.872z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
